import React from "react";
import FormTitle from "./FormTitle/FormTitle";
import "./FormContainer.css";

class FormContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formIsOpen: false,
    };

    this.handleFormOpen = this.handleFormOpen.bind(this);
  }

  handleFormOpen() {
    this.setState({
      formIsOpen: !this.state.formIsOpen,
    });
  }

  render() {
    return (
      <div
        className={
          "form rounded-form rounded-form-" + this.props.containerClass
        }
      >
        <div className="rounded-form-title" onClick={this.handleFormOpen}>
          <FormTitle
            formIsOpen={this.state.formIsOpen}
            formTitle={this.props.formTitle}
          />
        </div>
        <div
          className={
            this.state.formIsOpen
              ? "rounded-form-body rounded-form-body-open"
              : "rounded-form-body"
          }
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default FormContainer;
